import axios from 'axios';
import {TokenExpires} from './TokenExpires';

const url = process.env.REACT_APP_BASE_URL;

export const getProfileDetails = async (setIsLoading) => {
  setIsLoading(true)
  console.log("im a session");
  try {
    await axios
      .get(`${url}/get_finvesta_user_profile`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
        }
      })

        .then((res)=>{
            let data=res.data
            setIsLoading(false)
            Object.entries(data).map(([key,value])=>{
                sessionStorage.setItem(key,value)
            })
            if(!sessionStorage.getItem('reloaded')){
                sessionStorage.setItem('reloaded',true)
                window.location.reload();
            }
        })

    } catch (error) {
      TokenExpires(error)
        console.log(error)
        setIsLoading(false)
    }
}

export const getProfileDetailsOnce=async(setIsLoading,setUserDetails)=>{
  setIsLoading(true)
  try {
      await axios.get(`${url}/get_finvesta_user_profile`,{
          headers:{
              Authorization:`Bearer ${sessionStorage.getItem('UserToken')}`
          }
      })

      .then((res)=>{
         setUserDetails(res.data)
         setIsLoading(false)

      })

  } catch (error) {
    TokenExpires(error)
      console.log(error)
      setIsLoading(false)
  }
}

export const getAllDocuments=async(setData)=>{
  try {
    await axios.get(`${url}/get_finvesta_user_document_list`,{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem('UserToken')}`
      }
    })
    .then((res)=>{
      setData(res.data)
    })
  } catch (error) {
    TokenExpires(error)
    console.log(error);
  }
}